import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Loading } from '@/components/ui/daisy';
import { FileTree } from '@/components/ui/daisy/templates/file-tree';
import usePedWorkspace from '@/data/hook/ped-content/usePedWorkspace';
import { mountKey } from '@/utils/courses';
import { scrollBarYClassName } from '@/utils/scrollBarClassName';
import { twMerge } from 'tailwind-merge';
import CoursePedTree from '@/components/ped-content/CoursePedTree';
import { useTreeCourses } from '@/data/context/TreeCoursesContext';

export default function UnitsFileTree() {
  const { coursePath, isLoading, slug } = usePedWorkspace();
  const { tree } = useTreeCourses();
  const key = mountKey({ type: 'course', id: slug ?? '' });
  const parentKey = tree?.current.getParent(key);

  return (
    <div className="relative max-xl:w-72 w-xs rounded-2xl bg-base-100 shadow-default h-fit">
      <FileTree
        className={twMerge('max-h-[calc(100vh-150px)]', scrollBarYClassName)}
        size="md"
      >
        <ConditionalRenderer condition={isLoading}>
          <Loading size="xs" color="primary" />
        </ConditionalRenderer>
        {coursePath && parentKey && (
          <CoursePedTree item={coursePath} parentId={parentKey.id} />
        )}
      </FileTree>
    </div>
  );
}
